<script setup>
defineProps({
	spacious: {
		type: Boolean,
		default: false,
	},
})
</script>

<template>
	<div
		class="flex w-full flex-wrap items-center gap-2"
		:class="spacious ? 'sm:gap-3' : ''"
	>
		<div v-if="$slots.leading" class="flex min-w-0 w-full flex-wrap items-center gap-2 sm:w-auto">
			<slot name="leading" />
		</div>
		<div
			class="flex min-w-0 w-full flex-wrap items-center gap-2 sm:ml-auto sm:w-auto [&>form]:order-1 [&>form]:basis-full sm:[&>form]:order-2 sm:[&>form]:basis-auto [&>.dropdown-wrapper]:order-2 sm:[&>.dropdown-wrapper]:order-1 [&>ul]:order-3 [&>.view-mode-switcher]:order-3 [&>ul]:ml-auto [&>.view-mode-switcher]:ml-auto sm:[&>ul]:ml-0 sm:[&>.view-mode-switcher]:ml-0"
			:class="spacious ? 'sm:gap-3' : ''"
		>
			<slot />
		</div>
	</div>
</template>
